/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type WorkstreamReadinessAttentionAdminSendResponse = {
    audience: WorkstreamReadinessAttentionAdminSendResponse.audience;
    candidates_checked: number;
    actionable_recipients: number;
    anchors_created: number;
    anchors_reused: number;
    slack_scheduled: number;
    email_scheduled: number;
    main_gate_skips: number;
    delivery_gate_skips: number;
    dormant_skips: number;
};

export namespace WorkstreamReadinessAttentionAdminSendResponse {

    export enum audience {
        MYSELF = 'myself',
        ADMINS = 'admins',
    }


}

